import { Directive, ElementRef, inject } from '@angular/core';
import { SideMenuService } from '../services/side-menu.service';

@Directive({
  selector: '[appHoverToggle]',
  standalone: true,
  host: { '(mouseenter)': 'onMouseEnter()', '(mouseleave)': 'onMouseLeave()' },
})
export class HoverToggleDirective {
  private elementRef = inject(ElementRef);
  private sideMenuService = inject(SideMenuService);

  onMouseEnter() {
    this.handleHover(true);
  }

  onMouseLeave() {
    this.handleHover(false);
  }

  private handleHover(isHovered: boolean) {
    const state = this.sideMenuService.state$.getValue();
    if (!state.collapsed) {
      this.sideMenuService.isHovered$.next(false);
      return;
    }

    const element = this.elementRef.nativeElement;
    const hasCollapsedClass: boolean = element.classList.contains('collapsed');

    if (isHovered === hasCollapsedClass) {
      element.classList.toggle('collapsed');
      this.sideMenuService.isHovered$.next(isHovered);
    }
  }
}
